import { Autocomplete, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import CustomDialog from "components/custom/CustomDialog";
import { CustomButton } from "components/roundedbutton/CustomButton";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import HeaderOuBannerDependendoDaInterpretacaoH1 from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1";
import { IAbstractModel } from "model/abstract.model";
import { useEffect, useState } from "react";
import { CadastroPessoaService } from "../cadastro-pessoa.service";
import { deepClone, RemoveNull } from "utils/util";
import useCatchApiError from "hooks/useCatchApiError";

type Props = {
  open: boolean;
  onClose: () => void;
};

type LocalState = {
  nome: string | null;
  pais: IAbstractModel | null;
  paises: IAbstractModel[];
};

const initialState: LocalState = {
  nome: null,
  pais: null,
  paises: [],
};

const CadastroMunicipio = (props: Props) => {
  const [localState, setLocalState] = useState(deepClone(initialState));

  const cadastroPessoaService = CadastroPessoaService();
  const { addError, addSuccess } = useSnackbarCustom();
  const { throwErrorMessage } = useCatchApiError();

  const handleClose = () => {
    props.onClose();

    setTimeout(() => {
      setLocalState(deepClone(initialState));
    }, 200);
  };

  const handleSave = () => {
    if (!isValid) {
      return addError({
        message: 'Preencha todos os campos obrigatórios!',
        closeable: true,
        preventDuplicate: true,
        id: 'required-fields-error'
      });
    }

    const { paises, ...payload } = localState;
    cadastroPessoaService.saveMunicipio(payload as RemoveNull<typeof payload>)
      .then(({ data }) => {
        addSuccess({
          message: 'Munícipio salvo com sucesso!',
          closeable: true,
          preventDuplicate: true,
        });

        handleClose();
      })
      .catch(throwErrorMessage);
  };

  const isValid = !!localState.nome && !!localState.pais;

  useEffect(() => {
    if (!props.open) return;
    cadastroPessoaService.listPais()
      .then(({ data }) => {
        setLocalState(prev => ({ ...prev, paises: data.values }));
      })
      .catch();
    //eslint-disable-next-line
  }, [props.open]);


  return (
    <CustomDialog
      open={props.open}
      fullWidth
      onClose={handleClose}
      maxWidth={'sm'}
    >
      <DialogTitle style={{ textAlign: "center" }}>
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id='cadastro-municipio'
          iconClassName='fa-solid fa-city'
          label='Cadastrar município'
          small
        />
      </DialogTitle>

      <DialogContent
        sx={{
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px'
        }}
      >
        <TextField
          label="Nome *"
          value={localState.nome ?? ''}
          onChange={e => {
            setLocalState(prev => ({ ...prev, nome: e.target.value }));
          }}
          fullWidth
          variant="standard"
          type="text"
        />

        <Autocomplete
          value={localState.pais}
          id="acPais"
          options={localState.paises}
          getOptionLabel={(option) => option.descritivo}
          noOptionsText={'Nenhum resultado encontrado'}
          onChange={(_, value) => setLocalState(prev => ({ ...prev, pais: value }))}
          isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.uuid}>
                {option.descritivo}
              </li>
            );
          }}
          renderInput={
            (params) => <TextField {...params}
              label="País *"
              variant="standard"
            />}
        />
      </DialogContent>

      <DialogActions>
        <CustomButton
          disabled={!isValid}
          onClick={handleSave}
          variant="contained"
          color="success"
        >
          Salvar
        </CustomButton>

      </DialogActions>

    </CustomDialog>
  );
};

export default CadastroMunicipio;
